import { useQuery } from "@tanstack/react-query";

const BASE = "/api";

export interface InboxUnreadCount {
  dms: number;
  comments: number;
}

interface ApiResp { data: InboxUnreadCount }

async function fetchUnread(brandId: string): Promise<InboxUnreadCount | null> {
  const r = await fetch(`${BASE}/brands/${brandId}/inbox/unread-count`, {
    credentials: "include",
  });
  if (r.status === 404) return null; // INBOX_DISABLED — gracefully hide UI
  if (!r.ok) throw new Error("Failed to load inbox unread count");
  const json = (await r.json()) as ApiResp;
  return json.data;
}

/**
 * Returns the brand-scoped DM + comment unread counts. Returns `null` (via the
 * `enabled` data flow) when the brand has no Instagram account — the caller
 * uses that to hide the Inbox sidebar entry. Refetches every 30s and on focus.
 */
export function useInboxUnread(brandId: string | null | undefined) {
  return useQuery({
    queryKey: ["inbox-unread", brandId],
    queryFn: () => fetchUnread(brandId!),
    enabled: !!brandId,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    // Don't retry the 404 — it's a stable "no IG account" signal.
    retry: false,
    staleTime: 15_000,
  });
}
